import sdl from '@jds/react-generated-sdl/JDSCarouselSlide';
import type { JDSCarouselSlideProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, CarouselSlideProps } from '../logic';

const Component = (props: CarouselSlideProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { active = false, forward = true, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { active, forward, ...rest },
    'JDSCarouselSlide',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const CarouselSlide = withLogic(Component) as React.FC<CarouselSlideProps> & {
  slotName?: string;
};

CarouselSlide.displayName = 'CarouselSlide';
CarouselSlide.slotName = 'jds_carousel_slide';

export { CarouselSlide, type JDSCarouselSlideProps };
